import Vue from 'vue'
import VueI18n from 'vue-i18n'
import App from './Home/Home.vue'
import messages from './i18n/i18n.json'
import './styles/index.css'

Vue.config.productionTip = false

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: 'fr',
  messages
})

new Vue({
  i18n,
  render: h => h(App),
}).$mount('#app')
